import { render, staticRenderFns } from "./LogoWechatIcon.vue?vue&type=template&id=492f19a6&"
import script from "./LogoWechatIcon.vue?vue&type=script&lang=js&"
export * from "./LogoWechatIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports